import React from 'react'
import Link from 'next/link'
import { Image } from '@/atoms/Image'

type Sources = {
  mobile: string
  tablet: string
  desktop: string
  video?: string
}
interface VideoBannerProps {
  theatricalSlug?: string
  sources: Sources
  href?: string
}
const BANNER_CONFIGS = {
  desktop: {
    containerStyles: 'absolute inset-x-0 bottom-0 p-0 @container/banner',
    wrapperStyles:
      'text-[#4d3a86] @xs/banner:ml-[3%] @xs/banner:pb-[3%] @lg/banner:ml-[0] @lg/banner:pb-[0] @xl/banner:ml-[0.5%] @xl/banner:pb-[0.5%] @3xl/banner:ml-[1%] @3xl/banner:pb-[1%] @4xl/banner:ml-[0.5%] @4xl/banner:pb-[0.5%] @7xl/banner:ml-[1%] @7xl/banner:pb-[1%]',
    buttonStyles: `!text-[#4d3a86] text-xs @lg/banner:text-[10px] @2xl/banner:text-sm @3xl/banner:text-md @5xl/banner:text-lg @7xl/banner:text-xl !ring-0 !ring-transparent`,
    imageSize: {
      height: 334,
      width: 2000,
    },
    videoStyles: 'z-20 right-0',
  },
  tablet: {
    containerStyles: 'absolute inset-x-0 bottom-0 p-0 @container/banner',
    wrapperStyles: 'ml-[2%] pb-[2%] text-[#4d3a86] @xl/banner:ml-[2%] @xl/banner:pb-[2%]',
    buttonStyles: `!text-[#4d3a86] text-base !ring-0 !ring-transparent`,
    imageSize: {
      height: 300,
      width: 1200,
    },
    videoStyles: 'z-10 -right-[2em]',
  },
  mobile: {
    containerStyles: 'absolute inset-x-0 bottom-0 p-0 @container/banner',
    wrapperStyles: 'ml-[1%] pb-[3%] text-[#4d3a86]',
    buttonStyles: `text-[11px] @md/banner:text-sm !ring-0 !ring-transparent !text-[#4d3a86]`,
    imageSize: {
      height: 286,
      width: 856,
    },
    videoStyles: 'z-10 -right-[4em]',
  },
}

const createOverlay = (size: 'desktop' | 'tablet' | 'mobile', sources: Sources, href?: string) => {
  const config = BANNER_CONFIGS[size]
  const imageSize = config.imageSize
  const imageSrc = sources[size]

  const content = (
    <div className="relative min-h-[100px] w-full overflow-hidden rounded-xl">
      <video
        preload="auto"
        className={`${config.videoStyles} absolute bottom-0  h-full w-auto rounded-xl  object-contain`}
        autoPlay
        loop
        muted
        playsInline
        src={
          sources.video
            ? sources.video
            : 'https://images.angelstudios.com/video/upload/q_auto,f_auto,vc_auto,so_auto,br_500k,w_auto/v1743466597/king-of-kings/outputcat.webm'
        }
      />
      <Image
        className="relative z-20 h-full w-full rounded-xl"
        src={imageSrc}
        alt={''}
        width={imageSize.width}
        height={imageSize.height}
      />
    </div>
  )

  return (
    <div className={`relative mb-2 rounded-xl  bg-[#ece3f0]`}>
      {href ? (
        <Link href={href} target="_blank" className="block cursor-pointer">
          {content}
        </Link>
      ) : (
        content
      )}
    </div>
  )
}

export const VideoBanner: React.FC<VideoBannerProps> = ({ sources, href }) => {
  return (
    <div className="relative mb-2 min-h-[100px] @container ">
      <div className="relative hidden lg:block ">{createOverlay('desktop', sources, href)}</div>
      <div className="relative hidden md:block lg:hidden">{createOverlay('tablet', sources, href)}</div>
      <div className="relative md:hidden">{createOverlay('mobile', sources, href)}</div>
    </div>
  )
}
